module.exports = __webpack_public_path__ + "media/images/emblems/Kleinboesingen-coat_of_arms-9c3d0887df3e59826fdafe8d056bcf67.svg";